import { Component, Vue } from 'vue-property-decorator';

// gql
import fetchCarriersQuery from '@/graphql/queries/FetchCarriers.gql';

import { SelectOption } from '@/types/types';
import {
  CarrierFields,
  CarrierTypeEnum,
  TransportationTypeEnum
} from '@/types/graphql/schemaTypes';

@Component({
  apollo: {
    carrierOptions: {
      query: fetchCarriersQuery,
      debounce: 300,
      prefetch: true,
      variables() {
        return {
          filter: {
            carrierType: this.carrierType,
            search: this.searchCarrier || null
          }
        };
      },
      update(data): SelectOption<string>[] {
        if (data.carriers) {
          return data.carriers.map((carrier: CarrierFields) => {
            return {
              label: `${carrier.naccsCode} - ${carrier.name}`,
              value: carrier
            };
          });
        }
        return [];
      }
    }
  }
})

export default class CarrierOptionsMixin extends Vue {
  public carrierOptions: SelectOption<string>[] = [];
  public carrierType: CarrierTypeEnum | null = null;
  public searchCarrier = '';

  public setCarrierType(transportationType: TransportationTypeEnum | null) {
    switch (transportationType) {
      case TransportationTypeEnum.air:
        this.carrierType = CarrierTypeEnum.air;
        break;
      case TransportationTypeEnum.sea:
        this.carrierType = CarrierTypeEnum.sea;
        break;
      default:
        this.carrierType = null;
        break;
    }
  }
}
